import { Reveal } from "@frontend/components/site/reveal";
import { Section } from "@frontend/components/site/section";
import { FAQS } from "@frontend/components/site/faq-data";

export { FAQS };

export function Faq() {
  return (
    <Section id="faq" className="bg-white">
      <div className="grid gap-10 lg:grid-cols-[minmax(0,18rem)_minmax(0,1fr)] lg:gap-16">
        <Reveal>
          <p className="mkt-kicker">Questions</p>
          <h2 className="mkt-display mt-4 text-4xl leading-[1.05] sm:text-5xl">
            Before you <span className="mkt-serif text-[#0a9f56]">sign up</span>
          </h2>
        </Reveal>

        <div>
          {FAQS.map((item, index) => (
            <Reveal key={item.question} delay={index * 40} className="border-t border-ink/10">
              <details className="group">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-lg font-medium text-ink transition hover:text-ink/70 [&::-webkit-details-marker]:hidden">
                  {item.question}
                  <span
                    aria-hidden="true"
                    className="flex size-8 shrink-0 items-center justify-center rounded-full bg-ink text-lg leading-none text-white transition duration-300 group-open:rotate-45 group-open:bg-[#0ecf6f] group-open:text-ink"
                  >
                    +
                  </span>
                </summary>
                <p className="max-w-2xl pb-5 text-[15px] leading-relaxed text-ink/55">
                  {item.answer}
                </p>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
